import {
  Box,
  Button,
  Card,
  FormControl,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  useAddFaqMutation,
  useLazyDeleteFaqQuery,
  useLazyGetFaqQuery,
} from "../../services/cms";
import { Faqs } from "../../types/General";
import { Loader, showError, showToast } from "../../constants";
import useAuth from "../../hooks/useAuth";
import { Permissions } from "../../types/User";

type PropType = {
  hidePermission?: Permissions | null | undefined;
};

const Faq = ({ hidePermission }: PropType) => {
  const userData = useAuth();
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [faqs, setFaqs] = useState<Faqs[]>([]);
  const [getFaqData, { isLoading }] = useLazyGetFaqQuery();
  const [postFaq, postFaqData] = useAddFaqMutation();
  const [deleteFaq] = useLazyDeleteFaqQuery();

  const handleAddFaq = async () => {
    const newFaq = {
      question: question,
      answer: answer,
    };

    try {
      const res = await postFaq(newFaq).unwrap();
      if (res?.statusCode === 200) {
        getAllFaqsHandler();
        showToast("FAQ added successfully");
        setQuestion("");
        setAnswer("");
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  const getAllFaqsHandler = async () => {
    try {
      const res = await getFaqData({}).unwrap();
      if (res?.statusCode === 200) {
        setFaqs(res?.data || []);
      }
    } catch (error: any) {
      console.log(error);
    }
  };
  const handleDeleteFaq = async (id: string) => {
    try {
      const res = await deleteFaq({ faq_id: id }).unwrap();
      if (res?.statusCode === 200) {
        getAllFaqsHandler();
      }
    } catch (error: any) {
      showError(error?.message || "");
    }
  };
  useEffect(() => {
    getAllFaqsHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={2}>
      <Loader isLoad={isLoading} />
      {faqs?.map((item, index) => {
        return (
          <Grid key={index} item xs={12}>
            <Box className="faq_box">
              <FormControl sx={{ mb: 2, width: "100%" }}>
                <Typography className="custom_label">Question</Typography>
                <TextField
                  hiddenLabel
                  type={"text"}
                  name="name"
                  variant="outlined"
                  value={item?.question}
                  placeholder="Question"
                ></TextField>
              </FormControl>
              <FormControl sx={{ width: "100%" }}>
                <Typography className="custom_label">Answer</Typography>
                <TextField
                  hiddenLabel
                  type={"text"}
                  name="name"
                  variant="outlined"
                  value={item?.answer}
                  placeholder="Answer"
                ></TextField>
              </FormControl>
              {hidePermission?.isDelete || userData?.role === "ADMIN" ? (
                <Button
                  variant="contained"
                  className="btn sm"
                  onClick={() => handleDeleteFaq(item?._id)}
                >
                  Remove
                </Button>
              ) : null}
            </Box>
          </Grid>
        );
      })}

      <Grid item xs={12}>
        <Box className="faq_box">
          <FormControl sx={{ mb: 2, width: "100%" }}>
            <Typography className="custom_label">Question</Typography>
            <TextField
              hiddenLabel
              type={"text"}
              name="name"
              variant="outlined"
              value={question}
              onChange={(val) => setQuestion(val.target.value)}
              placeholder="Question"
            ></TextField>
          </FormControl>
          <FormControl sx={{ width: "100%" }}>
            <Typography className="custom_label">Answer</Typography>
            <TextField
              hiddenLabel
              type={"text"}
              name="name"
              variant="outlined"
              value={answer}
              onChange={(val) => setAnswer(val.target.value)}
              placeholder="Answer"
            ></TextField>
          </FormControl>
          {hidePermission?.isEdit || userData?.role === "ADMIN" ? (
            <Button
              variant="contained"
              disabled={!question || !answer}
              className="btn btn_primary sm"
              onClick={handleAddFaq}
            >
              {" "}
              Add{" "}
            </Button>
          ) : null}
        </Box>
      </Grid>
    </Grid>
  );
};

export default Faq;
